export default {
  client_equip_details_revision_history_title: "Revision History",
  client_equipaments_title: "My Equipment",
  client_home_quote_service_card: "Quote a Service",
  client_home_my_quotations_card: "Service Status",
  client_home_my_equipments_card: "My Equipment",
  client_quotations_page_title: "Service Status",
  client_quotations_home_breadcrumb: "Home",
  client_quotations_new_quote_btn: "New Quote",
  client_quotations_pending_section: "Waiting for My Action",
  client_quotations_processing_section: "Bepi Service",
  client_quotations_finished_section: "Finished",
  client_quotations_no_quotations: "No quotations in this category.",
  client_quotations_view_details_btn: "View Details",
  client_quote_page_title: "New Estimate",
  client_quote_home_breadcrumb: "Home",
  client_quote_quote_breadcrumb: "Quote a Service",
  client_quote_search_title: "Which equipment are you seeking service for?",
  client_quote_search_placeholder: "Lanyard",
  client_quote_search_empty_result: "No service found for the provided search.",
  client_quote_success_saving_quote_msg: "Quote sent successfully!",
  client_quote_cart_delete_title: "Delete item?",
  client_quote_cart_delete_warning: "This action cannot be undone.",
  client_quote_cart_delete_confirm: "Yes, delete",
  client_quote_cart_oficina_title: "Workshop Maintenance",
  client_quote_cart_empresa_title: "Maintenance at Company",
  client_quote_cart_item_singular: "item",
  client_quote_cart_item_plural: "items",
  client_quote_cart_in_oficina_chip: "At our workshop",
  client_quote_cart_in_client_chip: "At client",
  client_quote_cart_address_label: "Maintenance address:",
  client_quote_cart_qty_label: "Qty: ",
  client_quote_cart_model_label: "Model: ",
  client_quote_cart_brand_label: "Brand: ",
  client_quote_cart_problem_label: "Problem: ",
  client_quote_cart_tasks_label: "Tasks: ",
  client_quote_cart_multiple_addresses_title: "Warning: Multiple addresses",
  client_quote_cart_multiple_addresses_text: "You have items for #vr0# different addresses. Each address will be considered a separate visit.",
  client_quote_cart_page_title: "Quotation Estimate",
  client_quote_cart_home_breadcrumb: "Home",
  client_quote_cart_quote_breadcrumb: "Quote a Service",
  client_quote_cart_empty_title: "No items added yet",
  client_quote_cart_empty_subtitle: "Add services to create a quote",
  client_quote_cart_add_first_btn: "Add First Item",
  client_quote_cart_total_label: "Total: ",
  client_quote_cart_in_oficina_suffix: "  #vr0# at the workshop",
  client_quote_cart_addresses_suffix: " ⬢ #vr0# company #vr1#",
  client_quote_cart_address_singular: "address",
  client_quote_cart_address_plural: "addresses",
  client_quote_cart_add_new_btn: "Add New Item",
  client_quote_cart_request_quotes_btn: "Request Quotes",
  client_quote_modal_invalid_qty: "Invalid quantity",
  client_quote_modal_model_required: "Model is required",
  client_quote_modal_brand_required: "Brand is required",
  client_quote_modal_problem_required: "Problem is required",
  client_quote_modal_location_required: "Select maintenance location",
  client_quote_modal_address_required: "Address is required for maintenance at company",
  client_quote_modal_edit_title: "Editing: ",
  client_quote_modal_add_title: "Quoting: ",
  client_quote_modal_default_service: "Service",
  client_quote_modal_add_to_quote_btn: "Add to Quote",
  client_quote_modal_problem_label: "Problem or need",
  client_quote_modal_problem_placeholder: "Describe the problem or need in detail",
  client_quote_modal_location_label: "Maintenance Location",
  client_quote_modal_in_oficina_radio: "Workshop (Service)",
  client_quote_modal_in_empresa_radio: "InCompany (At my company)",
  client_quote_modal_address_label: "Company address",
  client_quote_modal_address_placeholder: "Inform the full address where the maintenance will be performed",
  client_quote_modal_tasks_label: "Additional tasks (optional)",
  client_quote_modal_obs_edit_label: "Observations",
  client_quote_modal_obs_auto_label: "Automatically generated observations",
  client_quote_modal_obs_helper: "These observations will be included in the quote",
  client_quote_search_cart_btn: "Cart (#vr0#)",
  client_quote_details_id_error: "Type or ID not found in URL",
  client_quote_details_load_error: "Error loading quote details",
  client_quote_details_num_label: "Estimate No.:",
  client_quote_details_location_label: "Location:",
  client_quote_details_items_label: "Items:",
  client_quote_details_value_label: "Value:",
  client_quote_details_page_title: "Quote Details",
  client_quote_details_loading: "Loading details...",
  client_quote_details_step_summary: "Estimate Summary",
  client_quote_details_step_shipping: "Shipping Guidance",
  client_quote_details_step_invoices: "Attach Shipping Invoices",
  client_quote_details_step_checkout: "Checkout",
  client_quote_details_shipping_title: "Follow the guidance below before sending the equipment.",
  client_quote_details_shipping_reference_title: "Shipping Instructions",
  client_quote_details_shipping_reference_hint: "Click the button below to view the complete equipment shipping instructions.",
  client_quote_details_shipping_open_page_btn: "Open Full Guidance",
  client_quote_details_shipping_review_checkbox: "I have read and understood the shipping guidance",
  client_quote_details_invoices_title: "Attach shipping invoices to unlock checkout.",
  client_quote_details_checkout_hint: "Review the final information and complete the quote flow.",
  client_quote_details_checkout_invoice_count: "Attached invoices:",
  client_quote_details_checkout_accept_estimate: "Accept Estimate",
  client_quote_details_checkout_refuse_estimate: "Refuse Estimate",
  client_quote_details_checkout_accept_budget: "Approve Budget",
  client_quote_details_checkout_refuse_budget: "Refuse Budget",
  client_quote_details_validation_summary: "Invalid estimate summary to proceed.",
  client_quote_details_validation_shipping: "Confirm shipping guidance review to proceed.",
  client_quote_details_validation_invoices: "Attach at least one shipping invoice to proceed.",
  client_quote_details_validation_checkout_unavailable: "There is no checkout action available for this quote yet.",
  client_quote_details_validation_generic: "Unable to proceed to the next step.",
  client_quote_details_refuse_reason_text: "Provide the reason for refusal:",
  client_quote_details_refuse_reason_placeholder: "Type the refusal reason...",
  client_quote_details_refuse_reason_required: "Please provide the refusal reason",
  client_quote_details_refuse_confirm_btn: "Confirm refusal",
  client_quote_details_refuse_error: "Could not refuse the estimate.",
  client_quote_details_budget_accept_title: "Approve budget",
  client_quote_details_budget_accept_text: "Do you want to approve this budget?",
  client_quote_details_budget_accept_confirm: "Approve",
  client_quote_details_budget_accept_error: "Could not approve the budget.",
  client_quote_details_budget_refuse_title: "Refuse budget",
  client_quote_details_budget_refuse_error: "Could not refuse the budget.",
  client_shipment_title: "Shipping Instructions",
  client_shipment_important_warning: "Important: If possible print and attach this document to the equipment. If you cannot print, write the quote number and your CNPJ on the packaging visibly.",
  client_shipment_quote_data_title: "Quote Data",
  client_shipment_estimate_num_label: "Estimate No.: ",
  client_shipment_cnpj_label: "CNPJ: ",
  client_shipment_sender_title: "Sender",
  client_shipment_client_label: "Client:",
  client_shipment_invoice_data_title: "Data for invoice issuance",
  client_shipment_ie_label: "I.E:",
  client_shipment_company_name_label: "Company Name:",
  client_shipment_address_label: "Address:",
  client_shipment_procedure_title: "Procedure for issuing the Shipping Invoice for Repair",
  client_shipment_procedure_step1: "Issue a \"Shipping for Repair\" invoice CFOP 5915 (SP state) or CFOP 6915 (other states).",
  client_shipment_procedure_step2: "Forward the copy of the Invoice to the email: fiscal@bunzl.com.br for us to release the equipment shipment.",
  client_shipment_procedure_step3: "Remembering that the shipment and withdrawal of equipment in our unit are the responsibility of the company contracting the service.",
  client_shipment_sedex_warning: "Acceptance of shipment via SEDEX exempts BUNZL from any responsibility for loss of material. The responsibility for posting lies with the contractor and the Post Office.",
  client_shipment_certificate_hint: "The equipment will be returned with Calibration/Adjustment Certificate, accompanied by the proper Invoices.",
  client_shipment_important_title: "Important",
  client_shipment_shipping_costs_warning: "Shipping and return costs are not included and are the responsibility of the contractor.",
  client_shipment_refusal_right_warning: "We reserve the right to refuse the service if, after examination, the Technical Center verifies that the equipment is in irreparable condition or with excessive damage.",
  client_shipment_incorrect_nf_warning: "In case of shipment with incorrect Invoice, the equipment will be returned to the address informed in the invoice with FOB freight.",
  client_shipment_doubts_help: "In case of doubts, contact our customer service.",
  client_shipment_home_btn: "Back to Home",
  client_shipment_print_btn: "Print Instructions",
  client_equip_details_download_error: "Equipment details download error.",
  client_equip_details_id_not_found: "Equipment ID not found",
  client_equip_details_item_data_title: "Equipment Data",
  client_equip_details_latest_photos_title: "Latest Equipment Photos",
  client_equip_details_not_found: "Equipment not found",
  client_equipaments_no_equipment_found: "Equipment no equipment found",
  client_equipaments_quote_pending_btn: "Quote Pending",
  client_home_welcome_question: "What would you like to do?",
  client_quotations_error_loading: "Error loading quotations.",
  client_quotations_filter_all_products: "All products",
  client_quotations_filter_product_label: "Filter by product",
  client_quotations_refresh_btn: "Refresh",
  client_quotations_table_product: "Product",
  client_quotations_view_kanban: "Kanban",
  client_quotations_view_list: "List",
  client_quote_catalog_error: "Failed to load service catalog.",
  client_quote_empty_error: "The quote is empty. Add items before sending.",
  client_quote_equipments_error: "Failed to load equipment.",
  client_quote_send_error: "Failed to send quote. Please try again.",
  client_help_modal_title: "Guide",
  client_help_modal_not_available: "No help available for this screen.",
  client_help_view_client_home_title: "Home",
  client_help_view_client_home_intro: "You are on the home screen. These are the main actions available:",
  client_help_view_client_home_item_quote: "Request a service quote.",
  client_help_view_client_home_item_quotations: "Track the status of your quotes.",
  client_help_view_client_home_item_equipments: "Manage your equipment.",
  client_help_view_client_quotation_title: "Service status",
  client_help_view_client_quotation_intro: "On this screen you can follow your quotes by sections and card types.",
  client_help_view_client_quotation_sections_heading: "Sections",
  client_help_view_client_quotation_section_waiting: "Waiting for my action: cases that need your action.",
  client_help_view_client_quotation_section_in_progress: "Bepi Service: cases currently in progress.",
  client_help_view_client_quotation_section_finished: "Finished: cases that were already completed.",
  client_help_view_client_quotation_cards_heading: "Card types",
  client_help_view_client_quotation_card_estimate: "Estimate: proposal with an estimated service value.",
  client_help_view_client_quotation_card_budget: "Budget: proposal with the final service value.",
  client_help_view_client_quotation_card_order: "Order: approved budget already in execution.",
  client_help_view_client_estimate_title: "How to request a quote",
  client_help_view_client_estimate_intro: "Follow this flow to build and send your quote:",
  client_help_view_client_estimate_step_1: "Choose the equipment you want to quote.",
  client_help_view_client_estimate_step_2: "Fill in item details and add it to the cart.",
  client_help_view_client_estimate_step_3: "Choose service location. If it is at your company, enter the full address.",
  client_help_view_client_estimate_closing: "Done. Click Request Quotes to finish.",
  client_help_view_client_equipments_title: "My equipment",
  client_help_view_client_equipments_intro: "Here you can find equipment that already went through maintenance.",
  client_help_view_client_equipments_item_history: "View maintenance history.",
  client_help_view_client_equipments_item_quote: "Request new services.",
  client_help_view_client_equipments_item_photos: "View equipment photos.",
  client_help_view_client_equipments_item_reports: "Download technical reports.",
  client_help_view_client_details_title: "Quote details",
  client_help_view_client_details_intro: "This screen shows available actions for estimate and budget stages.",
  client_help_view_client_details_estimate: "After receiving an estimate, you can accept or refuse it.",
  client_help_view_client_details_budget: "For the budget, you can also accept or refuse to continue the flow.",
  client_help_view_client_shipping_title: "Shipping guidance",
  client_help_view_client_shipping_intro: "Read this page carefully before shipping your equipment.",
  client_help_view_client_equipment_details_title: "Equipment details",
  client_help_view_client_equipment_details_intro: "Here you can find detailed information about equipment and maintenance.",
  client_quotations_table_ref: "Ref.",
  client_quotations_table_value: "Value",
  client_quotations_table_local: "Location",
  client_quotations_view_mode_label: "View mode",
  client_quotations_view_mode_aria_label: "Quotation view mode",
  client_quote_details_confirm_btn: "Confirm",
  client_quote_details_ok_btn: "OK",
  client_quote_details_warning_title: "Warning",
  client_quote_details_flow_lock_message: "The next steps will be available when the estimate is delivered.",
  client_quote_details_estimate_accept_title: "Accept estimate",
  client_quote_details_estimate_accept_text: "Confirm estimate acceptance to continue the flow?",
  client_quote_details_estimate_accept_confirm: "Confirm acceptance",
  client_quote_details_estimate_accept_success_title: "Estimate accepted",
  client_quote_details_estimate_accept_success_text: "Estimate acceptance was recorded successfully.",
  client_quote_details_estimate_accept_error: "Could not process estimate acceptance.",
  client_quote_details_estimate_refuse_title: "Refuse estimate",
  client_quote_details_estimate_refuse_success_title: "Estimate refused",
  client_quote_details_budget_refuse_success_title: "Budget refused",
  client_quote_details_refusal_success_message: "Refusal was recorded successfully.",
  client_quote_details_budget_accept_success_title: "Budget approved",
  client_quote_details_budget_accept_success_text: "Budget approved successfully.",
  client_quote_details_quote_number_title: "Quote #vr0#",
  client_quote_details_client_data_title: "Client Data",
  client_quote_details_client_contact_label: "Contact",
  client_quote_details_client_phone_label: "Phone",
  client_quote_details_client_email_label: "Email",
  client_quote_details_estimate_data_title: "Estimate Data",
  client_quote_details_response_label: "Response",
  client_quote_details_budget_deadline_label: "Deadline",
  client_quote_details_budget_validity_label: "Validity",
  client_quote_details_budget_notes_label: "Technician notes",
  client_quote_details_business_days_suffix: "business days",
  client_quote_details_item_fallback: "Item #vr0#",
  client_quote_details_qty_short_label: "Qty",
  client_quote_details_current_status_title: "Current Quote Status",
  client_quote_details_no_status: "No status",
  client_quote_details_budget_section_title: "Budget Data",
  client_shipment_loading: "Loading shipping instructions...",
  client_shipment_load_error: "Error loading shipping instructions.",
}

